import { render, staticRenderFns } from "./disclaimer.vue?vue&type=template&id=c4b6be02&scoped=true&"
import script from "./disclaimer.vue?vue&type=script&lang=js&"
export * from "./disclaimer.vue?vue&type=script&lang=js&"
import style0 from "./disclaimer.vue?vue&type=style&index=0&id=c4b6be02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b6be02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
